// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

export type BrandDomain = 'citec' | 'nuvara';

export const NUVARA_HOSTNAMES = new Set([
  'app.nuvara360.com',
  'advisor.nuvara360.com',
  'dev-app.nuvara360.com',
  'dev-advisor.nuvara360.com',
]);

export const getBrandDomainByHostname = (hostname: string): BrandDomain => {
  const normalizedHostname = hostname.toLowerCase();

  if (NUVARA_HOSTNAMES.has(normalizedHostname)) return 'nuvara';

  return 'citec';
};

export const getRuntimeBrandDomain = (): BrandDomain => {
  if (typeof window === 'undefined') return 'citec';

  return getBrandDomainByHostname(window.location.hostname);
};
